
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCentOffIec as ObiCentOffIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cent-off-iec.js';
 
 
 

 
 export const ObiCentOffIec = createComponent({
   react: React,
   tagName: 'obi-cent-off-iec',
   elementClass: ObiCentOffIecElement,
   events: {
     
   }
  });
 
 